import { createSelector } from '@ngrx/store';
import { AccountRegistrationsState } from '@store/reducers/account-registrations/account-registrations.reducer';

import * as fromFeature from '../../reducers/index';

export const selectAccountRegistrations = createSelector(
  fromFeature.getAccountRegistrationsState,
  (state: AccountRegistrationsState[]) => state,
);

export const selectAccountRegistrationsLoaded = createSelector(
  fromFeature.getAccountRegistrationsState,
  (state: AccountRegistrationsState[]) => state.length > 0,
);
